import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";
import UserForm from "../components/admin/UserForm";
import UserList from "../components/admin/UserList";
import { createUser, deleteUser, fetchAllUser, updateUser } from "../service/UserService";
import Main from "../components/admin/Main";

const User = () => {
  const [user, setUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [deletingId, setDeletingId] = useState(null);
  const loadUsers = async () => {
    try {
      setLoading(true);
      const res = await fetchAllUser();

      setUser(res);
    } catch (error) {
      toast("Error in fetch user", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);
  const handleSave = async (adData) => {
    try {
      const postData = {
        userId: adData.userId,
        username: adData.username,
        email: adData.email,
        password: adData.password,

      };

      if (selectedUser) {
        await updateUser(selectedUser.userId, postData);
        toast("user Updated", "SUCCESS");
      } else {
        await createUser(postData);
        toast("user Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedUser(null);
      setViewMode(false);
      await loadUsers();
    } catch (error) {
      toast("Error saving user", "ERROR");
    }
  };

  const handleEdit = (ad) => {
    setSelectedUser(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedUser(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleDelete = async (userId) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      try {
        setDeletingId(userId)
        await deleteUser(userId);
        toast("User Deleted", "SUCCESS");
        await loadUsers();
      } catch (error) {
        toast("Error in delete user", "ERROR");
      }finally{
        setDeletingId(null);
      }

    }
  };

  return (
    <Main>
      <PageContainer
        title="User"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedUser(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedUser(null);
            setViewMode(false);
          }}
          headerText={
            viewMode ? "View User" : selectedUser ? "Edit User" : "Add User"
          }
          centered
        >
          <UserForm
            initialData={selectedUser}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  })
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="User List">
          <UserList
            user={user}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
            deletingId={deletingId}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default User;
